import { openDB } from 'idb';


const productData =(data, flag,for_newPromotion) => {
    // alert('heloo')
    const saveData = async (data, flag) => {
      if (!("indexedDB" in window)) {
        console.warn("IndexedDB not supported");
        return;
      }

      const dbName = "gt_form";
      const storeName = "product_store";
      const version = 1; //versions start at 1

      const db = await openDB(dbName, version, {
        upgrade(db, oldVersion, newVersion, transaction) {
          const store = db.createObjectStore(storeName);       // eslint-disable-line
        }
      });
      const tx = await db.transaction(storeName, "readwrite");
      const store = await tx.objectStore(storeName);

    
        const isNewPromotion = await store.put({ "key": "is_newPromotion", "value": for_newPromotion },       // eslint-disable-line
         "is_newPromotion")        

 
    }

    saveData(data, flag)
    // if(isSaveDraft===false){
    //   // alert('data')
    // }
    // else{
    
    //   // alert('flag')
    // }
  }

export default class IsOutlet {
    
    static isoutlet(type,state,props){
        
     const isNew_createPromotion = (type,state,props) => {
        if(type === 'onEmpty') return productData(undefined, true,true)
         const {selectedOutletProgram,selectedLocationType,selectedTier,selectedPerfectVillage,
            selectedChannelTts,selectedChainOutlets,selectedPerfectStore,selectedPerfectStoreCompliance,
            selectedOutleClassification,selectedRange,selectedPointOfConsumption,selectedLoyalityProgram,
            selectedCustomerAttribute} = state
        let metadata = props.draftData?.ActivityMetadata?.outlet_attributes
      if(type === 'program'){
      for(let i=0;i<=selectedOutletProgram.length;i++ ){
        // ToastsStore.warning('false')
        let arr =metadata?.outet_programs ? metadata?.outet_programs :[]
      if(selectedOutletProgram[i]){
        if(arr.length===0){
         return  productData(undefined, true,true)
        }
        arr.some((cat,cat_index) => {
          // ToastsStore.success("inner filter ")
         return selectedOutletProgram[i]!==cat && productData(undefined, true,true)
        })
      }
      }
     }
      else if(type ===  'location'){
      for(let i=0;i<=selectedLocationType.length;i++ ){
        // ToastsStore.warning('false')
        let arr =metadata?.location_types ? metadata?.location_types :[]
      if(selectedLocationType[i]){
        if(arr.length===0){
          return  productData(undefined, true,true)
         }
        arr.some((cat,cat_index) => {
          // ToastsStore.success("inner filter ")
          return selectedLocationType[i]!==cat && productData(undefined, true,true)
        })
      }
      }
      }
       else if(type === 'tier'){
    
        for(let i=0;i<=selectedTier.length;i++ ){
          // ToastsStore.warning('false')
          let arr =metadata?.tiers ? metadata?.tiers :[]
        if(selectedTier[i]){
          if(arr.length===0){
            return  productData(undefined, true,true)
           }
          arr.some((cat,cat_index) => {
            // ToastsStore.success("inner filter ")
            return selectedTier[i]!==cat && productData(undefined, true,true)
          })
        }
        }

      }
    
        else if(type ===  'village'){
        for(let i=0;i<=selectedPerfectVillage.length;i++ ){
          // ToastsStore.warning('false')
          let arr =metadata?.perfect_villages ? metadata?.perfect_villages :[]
        if(selectedPerfectVillage[i]){
          if(arr.length===0){
            return  productData(undefined, true,true)
           }
          arr.some((cat,cat_index) => {
            // ToastsStore.success("inner filter ")
            return selectedPerfectVillage[i]!==cat && productData(undefined, true,true)
          })
        }
        }
        }
        else if(type ===  'channel_tts'){
            for(let i=0;i<=selectedChannelTts.length;i++ ){
              // ToastsStore.warning('false')
              let arr =metadata?.channel_tts ? metadata?.channel_tts :[]
            if(selectedChannelTts[i]){
              if(arr.length===0){
                return  productData(undefined, true,true)
               }
              arr.some((cat,cat_index) => {
                // ToastsStore.success("inner filter ")
                return selectedChannelTts[i]!==cat && productData(undefined, true,true)
              })
            }
            }
         }
         else if(type ===  'chain_outlet'){
            for(let i=0;i<=selectedChainOutlets.length;i++ ){
              // ToastsStore.warning('false')
              let arr =metadata?.chain_outlets ? metadata?.chain_outlets :[]
            if(selectedChainOutlets[i]){
              if(arr.length===0){
                return  productData(undefined, true,true)
               }
              arr.some((cat,cat_index) => {
                // ToastsStore.success("inner filter ")
                return selectedChainOutlets[i]!==cat && productData(undefined, true,true)
              })
            }
            }
         }
         else if(type ===  'store'){
            for(let i=0;i<=selectedPerfectStore.length;i++ ){
              // ToastsStore.warning('false')
              let arr =metadata?.perfect_stores ? metadata?.perfect_stores :[]
            if(selectedPerfectStore[i]){
              if(arr.length===0){
                return  productData(undefined, true,true)
               }
              arr.some((cat,cat_index) => {
                // ToastsStore.success("inner filter ")
                return selectedPerfectStore[i]!==cat && productData(undefined, true,true)
              })
            }
            }
         }
         else if(type ===  'store_compliance'){
            for(let i=0;i<=selectedPerfectStoreCompliance.length;i++ ){
              // ToastsStore.warning('false')
              let arr =metadata?.perfect_store_compliances ? metadata?.perfect_store_compliances :[]
            if(selectedPerfectStoreCompliance[i]){
              if(arr.length===0){
                return  productData(undefined, true,true)
               }
              arr.some((cat,cat_index) => {
                // ToastsStore.success("inner filter ")
                return selectedPerfectStoreCompliance[i]!==cat && productData(undefined, true,true)
              })
            }
            }
         }
         else if(type ===  'outlet_classification'){
            for(let i=0;i<=selectedOutleClassification.length;i++ ){
              // ToastsStore.warning('false')
              let arr =metadata?.outlet_classifications ? metadata?.outlet_classifications :[]
            if(selectedOutleClassification[i]){
              if(arr.length===0){
                return  productData(undefined, true,true)
               }
              arr.some((cat,cat_index) => {
                // ToastsStore.success("inner filter ")
                return selectedOutleClassification[i]!==cat && productData(undefined, true,true)
              })
            }
            }
         }
         else if(type ===  'range'){
            for(let i=0;i<=selectedRange.length;i++ ){
              // ToastsStore.warning('false')
              let arr =metadata?.ranges ? metadata?.ranges :[]
            if(selectedRange[i]){
              if(arr.length===0){
                return  productData(undefined, true,true)
               }
              arr.some((cat,cat_index) => {
                // ToastsStore.success("inner filter ")
                return selectedRange[i]!==cat && productData(undefined, true,true)
              })
            }
            }
         }
         else if(type ===  'consumption'){
            for(let i=0;i<=selectedPointOfConsumption.length;i++ ){
              // ToastsStore.warning('false')
              let arr =metadata?.point_of_consumptions ? metadata?.point_of_consumptions :[]
            if(selectedPointOfConsumption[i]){
              if(arr.length===0){
                return  productData(undefined, true,true)
               }
              arr.some((cat,cat_index) => {
                // ToastsStore.success("inner filter ")
                return selectedPointOfConsumption[i]!==cat && productData(undefined, true,true)
              })
            }
            }
         }
         else if(type ===  'loyality'){
            for(let i=0;i<=selectedLoyalityProgram.length;i++ ){
              // ToastsStore.warning('false')
              let arr =metadata?.loyalty_programs ? metadata?.loyalty_programs :[]
            if(selectedLoyalityProgram[i]){
              if(arr.length===0){
                return  productData(undefined, true,true)
               }
              arr.some((cat,cat_index) => {
                // ToastsStore.success("inner filter ")
                return selectedLoyalityProgram[i]!==cat && productData(undefined, true,true)
              })
            }
            }
         }
         else if(type ===  'customer_attribute'){
            for(let i=0;i<=selectedCustomerAttribute.length;i++ ){
              // ToastsStore.warning('false')
              let arr =metadata?.customer_attributes ? metadata?.customer_attributes :[]
            if(selectedCustomerAttribute[i]){
              if(arr.length===0){
                return  productData(undefined, true,true)
               }
              arr.some((cat,cat_index) => {
                // ToastsStore.success("inner filter ")
                return selectedCustomerAttribute[i]!==cat && productData(undefined, true,true)
              })
            }
            }
         }
       
     }
      return (
        isNew_createPromotion(type,state,props)
      )
    }
}